import * as signalR from '@microsoft/signalr';
import store from '../store';

let chatConnection: signalR.HubConnection;
let initialized = false;

export default {
  init() {
    if (initialized && chatConnection) {
      return;
    }

    chatConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HUB_ROOT + '/chathub', {
        accessTokenFactory: () => store.getters.token,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();

    initialized = true;
    chatConnection
      .start()
      .catch((e: any) =>
        console.error('[GroupChatHub] initial connect failed:', e)
      );
  },

  stop() {
    initialized = false;
    if (chatConnection) {
      chatConnection.stop();
    }
  },

  getConnection() {
    return chatConnection;
  },

  sendTyping(groupChatConversationId?: number | null) {
    if (chatConnection) {
      chatConnection
        .invoke('UserTyping', groupChatConversationId ?? null)
        .catch((err: any) => {
          console.error('[GroupChatHub] typing signal failed:', err);
        });
    }
  },
};
